var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCleane = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46.5,
  height: 46.5,
  x: 0.75,
  y: 0.75,
  stroke: "#183690",
  strokeWidth: 1.5,
  rx: 23.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#183690",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M38.5 12.55h-29a1.5 1.5 0 0 0-1.5 1.5v1.5a1.5 1.5 0 0 0 1.5 1.5h29a1.5 1.5 0 0 0 1.5-1.5v-1.5a1.5 1.5 0 0 0-1.5-1.5M10 17.05v9M14 17.05v9M18 17.05v9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#183690",
  strokeDasharray: "1.5 1.5",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M22 17.05v9M26 17.05v9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#183690",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M30 17.05v9M34 17.05v9M38 17.05v9M22 28.05q1.5 3 .5 6M26 28.05q1.5 3 .5 6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#183690",
  d: "M22.5 35.45a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8M26.5 35.45a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8"
})));
export default SvgCleane;